module.exports = __webpack_public_path__ + "static/media/activity-discursive.60c9ea80.svg";